import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { getAuth } from "firebase/auth";

import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Card,
  Divider,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  setDoc,
  doc,
  query,
  where,
  serverTimestamp,
  orderBy
} from "firebase/firestore";

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import { db } from "../Config/firebase";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";

const storage = getStorage();
const auth = getAuth();



        function getStatusVencimento(dataVencimento) {
          if (!dataVencimento || !dataVencimento.toDate) {
            return "ok";
          }

          const hoje = new Date();
          const vencimento = dataVencimento.toDate();

          const diffDias = Math.ceil(
            (vencimento - hoje) / (1000 * 60 * 60 * 24)
          );

          if (diffDias < 0) return "vencido";
          if (diffDias <= 45) return "alerta";
          return "ok";
        }


function getEstiloStatus(status) {
  if (status === "vencido") {
    return {
      bgcolor: "#fdecea",
      color: "#b71c1c",
      borderLeft: "6px solid #d32f2f"
    };
  }

  if (status === "alerta") {
    return {
      bgcolor: "#fff8e1",
      color: "#e65100",
      borderLeft: "6px solid #f9a825"
    };
  }

  return {};
}


/* =========================
   CALCULAR VENCIMENTO
========================= */
function calcularDataVencimento(dataISO, meses) {
  if (!dataISO || !meses) return null;
  const data = new Date(dataISO);
  data.setMonth(data.getMonth() + meses);
  return data;
}

export default function CadastroEquipamentoDetalhes() {
  const { equipamentoId } = useParams();
  const history = useHistory();

  const [equipamento, setEquipamento] = useState(null);
  const [docs, setDocs] = useState([]);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [pendentes, setPendentes] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [numeroCertificado, setNumeroCertificado] = useState("");
  const [certificadoAtivo, setCertificadoAtivo] = useState(null);
  const [semManual, setSemManual] = useState(false);
  const [novoEscopo, setNovoEscopo] = useState("geral");






  const [dialogNovoTipo, setDialogNovoTipo] = useState(false);
  const [dialogUpload, setDialogUpload] = useState(false);
  const [dialogHistorico, setDialogHistorico] = useState(false);

  const [tipoUpload, setTipoUpload] = useState(null);
  const [docExistente, setDocExistente] = useState(null);
  const [arquivo, setArquivo] = useState(null);
  const [dataReferencia, setDataReferencia] = useState("");

  const [novoNome, setNovoNome] = useState("");
  const [novoObrigatorio, setNovoObrigatorio] = useState(false);
  const [novoTemVencimento, setNovoTemVencimento] = useState(false);
  const [novoPeriodicidade, setNovoPeriodicidade] = useState("");
  const [novoDescricaoVencimento, setNovoDescricaoVencimento] = useState("");

  const [historicoSelecionado, setHistoricoSelecionado] = useState([]);
  const [uploadingCodigo, setUploadingCodigo] = useState(null);
  const [reload, setReload] = useState(0);

   async function marcarDocumentoComoDispensado(tipo) {
          const docRef = doc(collection(db, "eq_documentos"));

          await setDoc(docRef, aplicarTenantAtual({
            equipamentoId,
            tipoDocumentoCodigo: tipo.codigo,
            tipoDocumentoNome: tipo.nome,
            statusDocumento: "DISPENSADO",
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
          }));

          // ❌ NÃO salva histórico para "Sem manual"
          setReload(r => r + 1);
        }

  function fecharDialogUpload() {
  setDialogUpload(false);
  setArquivo(null);
  setDataReferencia("");
  setTipoUpload(null);
  setDocExistente(null);
  setNumeroCertificado("");
  setSemManual(false); // 👈 IMPORTANTE
}

  /* =========================
     EQUIPAMENTO
  ========================= */
  useEffect(() => {
    async function carregarEquipamento() {
      const snap = await getDoc(doc(db, "equipamentos", equipamentoId));
      setEquipamento({ id: snap.id, ...snap.data() });
    }
    carregarEquipamento();
  }, [equipamentoId]);

  /* =========================
     TIPOS DE DOCUMENTOS
  ========================= */
        useEffect(() => {
        async function carregarTipos() {
          const snap = await getDocs(
            consultaTenantAtual(query(collection(db, "eq_tipos_documentos")))
          );

          const tiposFiltrados = snap.docs
            .map(d => ({
              id: d.id,
              ...d.data()
            }))
            .filter(t => {
              // documentos antigos sem escopo → considerar geral
              if (!t.escopo) return true;

              if (t.escopo === "geral") return true;

              if (t.escopo === "especifico" && t.equipamentoId === equipamentoId)
                return true;

              return false;
            });

          // Evita exibir o mesmo tipo de documento mais de uma vez.
          // Se houver um tipo geral e outro específico com o mesmo nome,
          // mantém o específico deste equipamento.
          const tiposUnicos = new Map();

          tiposFiltrados.forEach(tipo => {
            const chave = (tipo.nome || "")
              .trim()
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");

            const existente = tiposUnicos.get(chave);

            if (
              !existente ||
              (tipo.escopo === "especifico" &&
                tipo.equipamentoId === equipamentoId)
            ) {
              tiposUnicos.set(chave, tipo);
            }
          });

          const lista = Array.from(tiposUnicos.values())
            .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

          setTiposDocumento(lista);
        }

        carregarTipos();
      }, [equipamentoId, reload]);


  /* =========================
     DOCUMENTOS DO EQUIPAMENTO
  ========================= */
  useEffect(() => {
    async function carregarDocs() {
      const q = query(
        collection(db, "eq_documentos"),
        where("equipamentoId", "==", equipamentoId),
        orderBy("createdAt", "desc")
      );

      const snap = await getDocs(consultaTenantAtual(q));

      const lista = await Promise.all(
          snap.docs.map(async d => {
            const data = d.data();

            let url = null;
            if (data.storagePathAtual) {
              url = await getDownloadURL(ref(storage, data.storagePathAtual));
            }

            return { id: d.id, ...data, url };
          })
        );


      setDocs(lista);
    }
    carregarDocs();
  }, [equipamentoId, reload]);

    /* =========================
     CERTIFICADO NA DESCRIÇÃO
  ========================= */
  useEffect(() => {
  // pega o PRIMEIRO documento que tenha número de certificado
  const docComCertificado = docs.find(
  d =>
    d.tipoDocumentoCodigo === "CERTIFICADO" &&
    d.statusDocumento === "ENVIADO"
);

  setCertificadoAtivo(docComCertificado || null);
}, [docs]);



  /* =========================
     CHECKLIST
  ========================= */
          useEffect(() => {
          if (!equipamento) return;

          // 🔹 Se o equipamento NÃO for calibrável, não há pendências
          if (equipamento.calibravel === false) {
            setPendentes([]);
            return;
          }

          const obrigatorios = tiposDocumento.filter(t => t.obrigatorio);

                const faltantes = obrigatorios.filter(tipo => {
                  const doc = docs.find(
                    d =>
                      d.tipoDocumentoCodigo === tipo.codigo &&
                      (d.statusDocumento === "ENVIADO" ||
                      d.statusDocumento === "DISPENSADO")
                  );

                  if (!doc) return true;

                  // Se for N/A → não é pendente
                  if (doc.statusDocumento === "DISPENSADO") return false;

                  // Se tem vencimento → validar se está vencido
                  if (tipo.temVencimento) {
                    const status = getStatusVencimento(doc.dataVencimento);
                    return status === "vencido";
                  }

                  return false;
                });

                setPendentes(faltantes);

        }, [docs, tiposDocumento, equipamento]);


  /* =========================
     UPLOAD / SUBSTITUIÇÃO
  ========================= */
  async function uploadDocumentoDireto(tipo, file, docExistente) {
    if (!file) return;

    setUploadingCodigo(tipo.codigo);

    let docRef;
    let revisao = 1;

    if (docExistente) {
      docRef = doc(db, "eq_documentos", docExistente.id);
      revisao = (docExistente.revisaoAtual || 1) + 1;
    } else {
      docRef = doc(collection(db, "eq_documentos"));
    }

    const rev = String(revisao).padStart(3, "0");
    const basePath = `eq/equipamentos/${equipamentoId}/${docRef.id}`;
    const storagePath = `${basePath}/v${rev}.pdf`;

    await uploadBytes(ref(storage, storagePath), file);

    const dataRefDate =
            tipo.temVencimento && dataReferencia
              ? new Date(`${dataReferencia}T12:00:00`)
              : null;

          const dataVencimento =
            tipo.temVencimento && dataReferencia
              ? calcularDataVencimento(
                  `${dataReferencia}T12:00:00`,
                  tipo.periodicidadeMeses
                )
              : null;

    await addDoc(collection(db, "eq_documentos_historico"), aplicarTenantAtual({
            equipamentoId,
            documentoId: docRef.id,

            tipoDocumentoCodigo: tipo.codigo,
            tipoDocumentoNome: tipo.nome,

            revisao,
            storagePath,

            nomeArquivoOriginal: file.name, // ✅ ESTA LINHA

            numeroCertificado: tipo.temVencimento ? numeroCertificado : null,
            dataVencimento,

            acao: docExistente ? "SUBSTITUICAO" : "INCLUSAO",
            usuarioUid: auth.currentUser.uid,
            usuarioEmail: auth.currentUser.email || "",
            criadoEm: serverTimestamp()
          }));


    


    await setDoc(
          docRef,
          aplicarTenantAtual({
            equipamentoId,
            tipoDocumentoCodigo: tipo.codigo,
            tipoDocumentoNome: tipo.nome,

            statusDocumento: "ENVIADO", // ✅ ESSENCIAL

            revisaoAtual: revisao,
            storagePathAtual: storagePath,

            nomeArquivoOriginal: file.name,
            numeroCertificado: tipo.temVencimento ? numeroCertificado : null,
            dataReferencia: dataRefDate,
            dataVencimento,

            updatedAt: serverTimestamp(),
            ...(docExistente ? {} : { createdAt: serverTimestamp() })
          }),
          { merge: true }
        );


    setUploadingCodigo(null);
    setReload(r => r + 1);
  }

  /* =========================
     HISTÓRICO
  ========================= */
  async function abrirHistoricoDocumento(documento) {
    if (documento.statusDocumento === "DISPENSADO") return;
    const q = query(
      collection(db, "eq_documentos_historico"),
      where("documentoId", "==", documento.id),
      orderBy("criadoEm", "desc")
    );

    const snap = await getDocs(consultaTenantAtual(q));
    setHistoricoSelecionado(
      snap.docs.map(d => ({ id: d.id, ...d.data() }))
    );
    setDialogHistorico(true);
  }

  if (!equipamento) return null;

  async function baixarVersao(storagePath) {
  if (!storagePath) return;

  try {
    const url = await getDownloadURL(ref(storage, storagePath));
    window.open(url, "_blank");
  } catch (err) {
    console.error("Erro ao baixar arquivo:", err);
    alert("Erro ao baixar o arquivo.");
  }
}
const exigeCertificado = tipoUpload?.temVencimento === true;

  return (
    <Box>
      <Navbar />

      <CabecalhoDetalhes titulo={equipamento.nome} subtitulo={equipamento.descricao}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => history.push("/app/cadastro-equipamentos")}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setDialogNovoTipo(true)}
        >
          Novo Tipo de Documento
        </Button>
      </CabecalhoDetalhes>

      <Box p={3}>
        <Card sx={{ mb: 3, p: 2 }}>
              {equipamento.calibravel && certificadoAtivo && (
                    <Typography
                      sx={{
                        mt: 1,
                        color:
                          getStatusVencimento(certificadoAtivo.dataVencimento) === "vencido"
                            ? "#b71c1c"
                            : "#e65100",
                        fontWeight: 500
                      }}
                    >
                      {getStatusVencimento(certificadoAtivo.dataVencimento) === "vencido"
                        ? "❌"
                        : "⚠️"}{" "}
                      Certificado: {certificadoAtivo.numeroCertificado}
                    </Typography>
                  )}



              <Divider sx={{ my: 2 }} />


          {pendentes.length === 0 ? (
            <Typography color="success.main">
              ✅ Checklist completo
            </Typography>
          ) : (
            pendentes.map(p => (
              <Typography key={p.codigo} color="error.main">
                ❌ {p.nome}
              </Typography>
            ))
          )}
        </Card>

        <Box
  sx={{
    mb: 2,
    display: "flex",
    justifyContent: "flex-end"
  }}
>
  <Box sx={{ width: 250 }}>
    <FormControl fullWidth size="small">
      <InputLabel>Status</InputLabel>
      <Select
        value={filtroStatus}
        label="Status"
        onChange={(e) => setFiltroStatus(e.target.value)}
      >
        <MenuItem value="todos">Todos</MenuItem>
        <MenuItem value="vencido">Vencidos</MenuItem>
        <MenuItem value="alerta">A vencer (≤ 45 dias)</MenuItem>
      </Select>
    </FormControl>
  </Box>
</Box>



        

        <List>
          {tiposDocumento
  .filter(tipo => {
    // 🔹 Se o equipamento NÃO for calibrável, ignora docs obrigatórios de calibração
    if (
      equipamento.calibravel === false &&
      tipo.obrigatorio === true &&
      tipo.temVencimento === true
    ) {
      return false;
    }

    return true;
  })
  .filter(tipo => {
    if (filtroStatus === "todos") return true;

    const enviado = docs.find(
        d =>
          d.tipoDocumentoCodigo === tipo.codigo &&
          (d.statusDocumento === "ENVIADO" || d.statusDocumento === "DISPENSADO")
      );


    if (!enviado) return false;

    const status = getStatusVencimento(enviado.dataVencimento);
    return status === filtroStatus;
  })
  .map(tipo => {


            const enviado = docs.find(
                  d =>
                    d.tipoDocumentoCodigo === tipo.codigo &&
                    (d.statusDocumento === "ENVIADO" || d.statusDocumento === "DISPENSADO")
                );

            const statusVencimento =
              enviado && enviado.statusDocumento === "ENVIADO"
                ? getStatusVencimento(enviado.dataVencimento)
                : "ok";



              return (
              <ListItemButton
                  key={tipo.codigo}
                  sx={{
                    justifyContent: "space-between",
                    ...(enviado ? getEstiloStatus(statusVencimento) : {})
                  }}
                >

                <ListItemText
                      primary={`${tipo.nome}${tipo.obrigatorio ? " (obrigatório)" : ""}`}
                      secondary={
                            !enviado
                              ? "❌ Pendente"
                              : enviado.statusDocumento === "DISPENSADO"
                              ? "ℹ️ Não aplicável (N/A)"

                              : tipo.temVencimento
                          ? `📄 Enviado • ${
                              statusVencimento === "vencido"
                                ? "❌ VENCIDO EM"
                                : statusVencimento === "alerta"
                                ? "⚠️ VENCE EM"
                                : "Vence em"
                            }: ${
                              enviado.dataVencimento?.toDate
                                ? enviado.dataVencimento.toDate().toLocaleDateString("pt-BR")
                                : "—"
                            }`
                          : "📄 Enviado"
                          }


                      sx={{
                        cursor: enviado ? "pointer" : "default",
                        "& .MuiListItemText-secondary": {
                          color:
                            statusVencimento === "vencido"
                              ? "#b71c1c"
                              : statusVencimento === "alerta"
                              ? "#e65100"
                              : "text.secondary"
                        }
                      }}
                     onClick={() =>
                          enviado &&
                          enviado.statusDocumento === "ENVIADO" &&
                          enviado.url &&
                          window.open(enviado.url, "_blank")
                        }

                    />


                        <Box sx={{ display: "flex", gap: 1 }}>
                          {enviado && enviado.statusDocumento === "ENVIADO" && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => abrirHistoricoDocumento(enviado)}
                                >
                                  Histórico
                                </Button>
                              )}



                        <Button
                          size="small"
                          variant="outlined"
                          disabled={uploadingCodigo === tipo.codigo}
                          onClick={() => {
                            setTipoUpload(tipo);
                            setDocExistente(enviado || null);
                            setDialogUpload(true);
                          }}
                        >
                  {uploadingCodigo === tipo.codigo ? (
                          <CircularProgress size={18} />
                        ) : enviado ? (
                          enviado.statusDocumento === "DISPENSADO"
                            ? "Carregar documento"
                            : "Substituir"
                        ) : (
                          "Carregar documento"
                        )}


                  </Button>
                  </Box>

                </ListItemButton>
                 );
              })}
            </List>
        </Box>

      {/* DIALOG UPLOAD */}
      <Dialog open={dialogUpload} onClose={fecharDialogUpload} fullWidth>

        <DialogTitle>Carregar Documento</DialogTitle>
        <DialogContent>
          {tipoUpload?.temVencimento && (
            <input
              type="date"
              style={{ width: "100%", padding: 10, marginBottom: 12 }}
              value={dataReferencia}
              onChange={e => setDataReferencia(e.target.value)}
            />
             

            
          )}
          {/* NÚMERO DO CERTIFICADO */}
          {tipoUpload?.temVencimento && (
                <input
                  style={{
                    width: "100%",
                    padding: 10,
                    marginBottom: 12
                  }}
                  placeholder="Número do certificado"
                  value={numeroCertificado}
                  onChange={e => setNumeroCertificado(e.target.value)}
                />
              )}
                 <FormControlLabel
                      control={
                        <Checkbox
                          checked={semManual}
                          onChange={e => setSemManual(e.target.checked)}
                        />
                      }
                      label="Não aplicável (N/A)"
                    />



         <Button component="label" variant="outlined">
                Selecionar arquivo
                <input
                  hidden
                  type="file"
                  onChange={e => setArquivo(e.target.files[0])}
                />
              </Button>             


              {/* ✅ NOME DO ARQUIVO SELECIONADO */}
              {arquivo && (
                <Typography
                  variant="body2"
                  sx={{ mt: 1, color: "text.secondary" }}
                >
                  📄 Arquivo selecionado: <strong>{arquivo.name}</strong>
                </Typography>
              )}
 



        </DialogContent>

        <DialogActions>

          <Button onClick={fecharDialogUpload}>Cancelar</Button>
                  

                   <Button
                          variant="contained"
                          disabled={
                            (!semManual && !arquivo) ||
                            (!semManual && exigeCertificado && !numeroCertificado) ||
                            (!semManual && tipoUpload?.temVencimento && !dataReferencia)
                          }
                          onClick={async () => {
                            fecharDialogUpload();

                            if (semManual) {
                              await marcarDocumentoComoDispensado(tipoUpload);
                            } else {
                              await uploadDocumentoDireto(tipoUpload, arquivo, docExistente);
                            }
                          }}
                        >
                          Salvar
                        </Button>





        </DialogActions>
      </Dialog>
      {/* =========================
    DIALOG – NOVO TIPO DE DOCUMENTO (EQUIPAMENTO)
========================= */}
<Dialog
  open={dialogNovoTipo}
  onClose={() => setDialogNovoTipo(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Novo Tipo de Documento</DialogTitle>

  <DialogContent>
    <input
      style={{ width: "100%", padding: 10, marginBottom: 12 }}
      placeholder="Nome do Documento"
      value={novoNome}
      onChange={e => setNovoNome(e.target.value)}
    />
     <FormControl fullWidth sx={{ mt: 2 }}>
  <InputLabel>Escopo do Documento</InputLabel>
  <Select
    value={novoEscopo}
    label="Escopo do Documento"
    onChange={(e) => setNovoEscopo(e.target.value)}
  >
    <MenuItem value="geral">
      Geral (para todos equipamentos)
    </MenuItem>
    <MenuItem value="especifico">
      Específico (somente este equipamento)
    </MenuItem>
  </Select>
</FormControl>


    <FormControlLabel
      control={
        <Checkbox
          checked={novoObrigatorio}
          onChange={e => setNovoObrigatorio(e.target.checked)}
        />
      }
      label="Documento obrigatório"
    />

    <FormControlLabel
      control={
        <Checkbox
          checked={novoTemVencimento}
          onChange={e => setNovoTemVencimento(e.target.checked)}
        />
      }
      label="Documento possui vencimento"
    />

    {novoTemVencimento && (
      <>
        <input
          type="number"
          style={{ width: "100%", padding: 10, marginTop: 12 }}
          placeholder="Periodicidade em meses (ex: 12)"
          value={novoPeriodicidade}
          onChange={e => setNovoPeriodicidade(e.target.value)}
        />

        <input
          style={{ width: "100%", padding: 10, marginTop: 12 }}
          placeholder="Descrição do vencimento (ex: Calibração anual)"
          value={novoDescricaoVencimento}
          onChange={e => setNovoDescricaoVencimento(e.target.value)}
        />
      </>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setDialogNovoTipo(false)}>
      Cancelar
    </Button>

    <Button
          variant="contained"
          onClick={async () => {
            if (!novoNome) return;

            const codigo = novoNome
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/\s+/g, "_");

            await addDoc(collection(db, "eq_tipos_documentos"), aplicarTenantAtual({
                  nome: novoNome,
                  codigo,
                  obrigatorio: novoObrigatorio,
                  temVencimento: novoTemVencimento,
                  periodicidadeMeses: novoTemVencimento
                    ? Number(novoPeriodicidade)
                    : null,
                  descricaoVencimento: novoDescricaoVencimento || null,

                  escopo: novoEscopo,
                  equipamentoId: novoEscopo === "especifico" ? equipamentoId : null,

                  ativo: true,
                  criadoEm: serverTimestamp(),
                  criadoPorUid: auth.currentUser.uid
                }));


            setDialogNovoTipo(false);
            setNovoNome("");
            setNovoObrigatorio(false);
            setNovoTemVencimento(false);
            setNovoPeriodicidade("");
            setNovoDescricaoVencimento("");

            setReload(r => r + 1);
          }}
        >
          Salvar
        </Button>

  </DialogActions>
</Dialog>
{/* =========================
    DIALOG – HISTÓRICO DO DOCUMENTO (EQUIPAMENTO)
========================= */}
<Dialog
  open={dialogHistorico}
  onClose={() => setDialogHistorico(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Histórico do Documento</DialogTitle>

  <DialogContent dividers>
    {historicoSelecionado.length === 0 ? (
      <Typography>Nenhum histórico encontrado.</Typography>
    ) : (
      historicoSelecionado.map(h => (
        <Box key={h.id} sx={{ mb: 2 }}>
          <Typography
                variant="subtitle2"
                sx={{
                  cursor: "pointer",
                  color: "primary.main",
                  textDecoration: "underline"
                }}
                onClick={() => baixarVersao(h.storagePath)}
              >
                📎 {h.nomeArquivoOriginal || `v${String(h.revisao).padStart(3, "0")}.pdf`}
              </Typography>


          <Typography variant="body2">
            📅 Data:{" "}
            {h.criadoEm?.toDate
              ? h.criadoEm.toDate().toLocaleString("pt-BR")
              : "—"}
          </Typography>

          <Typography variant="body2">
            👤 Responsável: {h.usuarioEmail || "Usuário não identificado"}
          </Typography>

          <Typography variant="body2">
            🔁 Ação: {h.acao === "SUBSTITUICAO" ? "Substituição" : "Inclusão"}
          </Typography>

          {h.numeroCertificado && (
  <Typography variant="body2">
    🧾 Certificado: {h.numeroCertificado}
  </Typography>
)}

{h.dataVencimento?.toDate && (
  <Typography variant="body2">
    ⏰ Vencimento:{" "}
    {h.dataVencimento.toDate().toLocaleDateString("pt-BR")}
  </Typography>
)}


          <Divider sx={{ mt: 1 }} />
        </Box>
      ))
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setDialogHistorico(false)}>
      Fechar
    </Button>
  </DialogActions>
</Dialog>


    </Box>
  );
}
